const navItemStyle = (theme, _params, classes) => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,

    '&.firstLine .MuiButton-root': {
      marginLeft: -8,
      width: 'calc(100% + 8px)',
    }
  },
  button: {
    color: theme.palette.text.secondary,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%'
  },
  buttonLeaf: {
    color: theme.palette.text.secondary,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      [`& .${classes.title}`]: {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    '&:disabled, &.Mui-disabled': {
      color: theme.palette.text.disabled,
      [`& .${classes.icon}`]: {
        color: theme.palette.text.disabled,
        opacity: 0.38,
        '& svg': {
          fill: theme.palette.text.disabled,
          color: theme.palette.text.disabled,
        }
      },
      [`& .${classes.title}`]: {
        color: theme.palette.text.disabled,
      }
    }
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    width: '20px',
    height: 'auto',
    marginTop: -2,
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    color: theme.palette.secondary.main,
    [`& .${classes.title}`]: {
      fontWeight: theme.typography.fontWeightMedium
    },
    [`& .${classes.icon}`]: {
      color: theme.palette.secondary.main
    }
  }
});

export default navItemStyle;
